import { useState } from 'react'
import { Button } from '../../components/button'
import { ConfirmationModal } from '../../components/modal/app_modals/confirmationModal'
import Spinner from '../../components/spinner/Spinner'
import { HeaderSubheader } from '../../components/typography/HeaderSubheader'
import { useModalControl } from '../../hooks/useModalControl'
import { AddOriginModal } from '../../components/modal/app_modals/addOriginModal'
import { TableComponent } from '../../components/table'
import Icon from '../../components/icon'
import {
  useDeleteOriginMutation,
  useGetAllOriginsQuery,
} from '../../redux-toolkits/origin/origin.slice'

export const Origin = () => {
  const [selectedOrigin, setSelectedOrigin] = useState<{
    name: string
    _id: string
  } | null>(null)

  const { modalOpen, modal, handleModalClose, handleModalOpen, setModalOpen } =
    useModalControl()

  const { data, isFetching } = useGetAllOriginsQuery({})
  const [deleting, { isLoading }] = useDeleteOriginMutation()

  if (isFetching) {
    return (
      <div
        className="
        flex items-center justify-center
      "
      >
        <Spinner fullScreen={false} />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <HeaderSubheader
          title="Origin"
          text="Configure fulfillment centre origin"
          className="max-w-fit"
        />

        <Button
          label="Add Origin"
          primary
          onClick={() => {
            handleModalOpen('AddOriginModal')
          }}
          size="medium"
          className="min-w-fit"
          type="button"
        />
      </div>

      <div className="w-full overflow-x-scroll max-w-[620px]">
        <TableComponent
          sortable={false}
          headers={['Origin']}
          rows={
            data?.data?.docs?.length
              ? data?.data?.docs?.map((item, idx) => {
                  return {
                    id: `${item._id}`,
                    content: [
                      <div
                        key={`${item._id}`}
                        className="
                      w-full
                      flex items-center justify-between
                      gap-4
                      "
                      >
                        {item.name}
                        <div className="flex flex-row space-x-4">
                          <button
                            type="button"
                            className="flex items-center gap-2"
                            onClick={() => {
                              setSelectedOrigin(item)
                              handleModalOpen('AddOriginModal')
                            }}
                          >
                            <Icon width={14} height={14} id="edit" />
                            Edit
                          </button>

                          <button
                            type="button"
                            className="flex items-center gap-2 text-danger"
                            onClick={() => {
                              setSelectedOrigin(item)
                              handleModalOpen('confirmOriginDeletionModal')
                            }}
                          >
                            <Icon width={14} height={14} id="bin" />
                            Delete
                          </button>
                        </div>
                      </div>,
                    ],
                  }
                })
              : []
          }
          name="quick-fund-table"
          loading={false}
          isEmpty={[undefined, 0].includes(data?.data?.docs?.length)}
          currentPage={1}
          totalDataCount={undefined}
          pageLimit={undefined}
          onPageChange={(page) => {}}
        />
      </div>

      <AddOriginModal
        origin={selectedOrigin}
        open={modalOpen && modal === 'AddOriginModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
          setSelectedOrigin(null)
        }}
      />

      <ConfirmationModal
        open={modalOpen && modal === 'confirmOriginDeletionModal'}
        setOpen={setModalOpen}
        message="Are you sure you want to proceed? This action cannot be reversed."
        onCloseCallback={() => {
          handleModalClose()
          setSelectedOrigin(null)
        }}
        onConfirm={async () => {
          if (selectedOrigin?._id) {
            const res = await deleting(selectedOrigin?._id)
            if (res?.data?.success) {
              handleModalClose()
              setSelectedOrigin(null)
            }
          }
        }}
        loading={isLoading}
      />
    </div>
  )
}
